import React, {SyntheticEvent, useEffect, useRef, useState} from "react";
import {Form, Input, Schema, SelectPicker} from "rsuite";
import ShippingAddress from "../../../../../interfaces/ShippingAddress";
import PaymentAndPickupData from "../../../../../interfaces/PaymentAndPickupData";
import {useTranslation} from "react-i18next";
import {CarrierType} from "../../../../../enums/CarrierType";
import {DeliveryType} from "../../../../../enums/DeliveryType";
import velotradeDeliveryService from "../../../../../services/velotradeDeliveryService";
import {ItemDataType} from "rsuite/cjs/@types/common";

interface SelectItem{
    label: string,
    value: string
}

const Field = React.forwardRef((props: any, ref: any) => {
    const { name, message, label, accepter, error, ...rest } = props;
    return (
        <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : ''}>
            <Form.ControlLabel>{label}</Form.ControlLabel>
            <Form.Control checkAsync={false} name={name} accepter={accepter} errorMessage={error} {...rest} />
            <Form.HelpText>{message}</Form.HelpText>
        </Form.Group>
    );
});

const DeliveryByAddress:React.FC<{onChange: Function, shippingAddress?: ShippingAddress | null,
    onPaymentAndPickupDataChange?: (data: PaymentAndPickupData) => void,
    showPayOnDelivery: boolean}> = ({onChange, shippingAddress, onPaymentAndPickupDataChange, showPayOnDelivery}) => {
    const {t} = useTranslation();
    const [tabIndex, setTabIndex] = useState(0);
    const [areas, setAreas] = useState<SelectItem[]>([])
    const [districts, setDistricts] = useState<SelectItem[]>([])
    const [cities, setCities] = useState<SelectItem[]>([])
    const [streets, setStreets] = useState<SelectItem[]>([])
    const deliveryPayer = [{label: t('deliveryPayer.sender'), value: 0}, {label: t('deliveryPayer.receiver'), value: 1}]
    const [selectedArea, setSelectedArea] = useState<string>();
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedStreet, setSelectedStreet] = useState('');


    const [address, setAddress] = useState<ShippingAddress>({
        carrierType: CarrierType.AddressDelivery,
        deliveryType: DeliveryType.CourierDelivery,
        id: shippingAddress ? shippingAddress.id : null,
        state: shippingAddress ? shippingAddress.state : '',
        stateId:  shippingAddress ? shippingAddress.stateId : null,
        city: shippingAddress ? shippingAddress.city : '',
        cityId: shippingAddress ? shippingAddress.cityId : null,
        district: '',
        districtId: null,
        postalCode: null,
        street: shippingAddress ? shippingAddress.street : '',
        streetId: shippingAddress ? shippingAddress.streetId : null,
        house: shippingAddress ? shippingAddress.house : '',
        apartment: shippingAddress ? shippingAddress.apartment : '',
        carrierBranch: shippingAddress ? shippingAddress.carrierBranch : '',
        carrierBranchId: shippingAddress ? shippingAddress.carrierBranchId : null,
        country: 'Україна',
        countryId: '6eb2dc1d-690e-483e-910d-178ca6fe3848',
    })

    const formRef = useRef<any>();
    const [formError, setFormError] = useState({});
    const [formValue, setFormValue] = useState({
        area: shippingAddress?.stateId,
        city: shippingAddress?.cityId,
        branch: shippingAddress?.carrierBranchId
    });
    const [formValueCourier, setFormValueCourier] = useState({
        area: shippingAddress?.stateId,
        city: shippingAddress?.cityId,
        street: shippingAddress?.street,
        house: shippingAddress?.house
    });
    const [formErrorAddress, setFormErrorAddress] = useState({});

    const area = t('delivery.area')
    const district = t('delivery.district')
    const city = t('delivery.city')
    const branch = t('delivery.branch')
    const street = t('delivery.street')
    const house = t('delivery.house')
    const apartment = t('delivery.apartment')
    const payer = t('delivery.payer')
    const sum = t('delivery.sum')

    const { StringType } = Schema.Types;
    const errorField = t('form.requiredFieldMsg')

    const modelAddress = Schema.Model({
        area: StringType().isRequired(errorField),
        district: StringType().isRequired(errorField),
        city: StringType().isRequired(errorField),
        street: StringType().isRequired(errorField),
        house: StringType().isRequired(errorField),
        //apartment: StringType().isRequired(errorField),
    });

    useEffect(() => {
        if (shippingAddress){
            setTabIndex(shippingAddress.deliveryType )
            saveDeliveryType(shippingAddress.deliveryType)
        }
    }, [])



    useEffect(() => {
        velotradeDeliveryService.getAreas().then(data => {
            setAreas(data.map(item => ({ label: item.name, value: item.id.toString() })))

            if(shippingAddress && shippingAddress.stateId) {
                let selected = data.find(item => item.id == +shippingAddress.stateId!);
                if(selected) {
                    setSelectedArea(selected.id.toString())
                }
            }
            if (data.length == 0) {
                setCities([]);
            }
        })
    }, [])

    const areaChange = (value: string , event: any) => {

        if (value) {
            setAddress({...address, state: value, stateId: value})

        }
    }


        const districtChange = (value: string , event: any) => {
            if (value) {
                setAddress({...address, district: value, districtId: value})
                setSelectedDistrict(value)
            }
        }

        const cityChange = (value: string , event: any) => {
            if (value) {
                setAddress({...address, city: value, cityId: value})
                setSelectedCity(value)
            }
        }

        const streetChange = (value: string , event: any) => {


            if (value) {
                setAddress({...address, street: value, streetId: value})
                setSelectedStreet(value)
            }

        }


        const [deliveryPayerVal, setDeliveryPayerVal] = useState<number | null>(null)
        const [orderAmountVal, setOrderAmountVal] = useState<number | null>(null)

        const deliveryPayerChange = (value: string | null, item: ItemDataType, event: SyntheticEvent<Element, Event>) => {
            setDeliveryPayerVal(+value!)
            if(onPaymentAndPickupDataChange) {
                onPaymentAndPickupDataChange({
                    deliveryPayer: +value!,
                    orderToPay: orderAmountVal,
                    carModel: null,
                    carNumber: null,
                    pickupDate: null,
                    pickupTime: null
                })
            }
        }

        const setOrderAmount = (value: string , event: any) => {
            setOrderAmountVal(+value)
            if(onPaymentAndPickupDataChange) onPaymentAndPickupDataChange({
                deliveryPayer: deliveryPayerVal,
                orderToPay: +value,
                carModel: null,
                carNumber: null,
                pickupDate: null,
                pickupTime: null
            })

        }

        /*const streetChange = (value: string , event: any) => {
            if (value) setAddress({...address, address: value})
        }*/

        const houseChange = (value: string , event: any) => {
            if (value) setAddress({...address, house: value})
        }

        const apartmentChange = (value: string , event: any) => {
            if (value) setAddress({...address, apartment: value})
        }

        const [isSaved, setIsSaved] = useState(false)

        const saveData = () => {
            if (formRef.current!.check()) {
                onChange({...address})
                setIsSaved(true)
            }
        }

        const saveDeliveryType = (deliveryTypeEnum: number) => {
            setAddress(({...address, deliveryType: deliveryTypeEnum}))
        }

        const focusInput = (el: any) => {

            const inputs = document.getElementsByClassName('rs-picker-search-bar-input')
            for (let i = 0; i < inputs.length; i++) {
                const slide = inputs[i] as HTMLElement;
                slide.focus();
            }
        }
    return (
        <div className="delivery-services-item delivery-dpd-wrapper">
            <Form model={modelAddress} ref={formRef} onCheck={setFormErrorAddress} formDefaultValue={formValueCourier}>
                <div className={formErrorAddress.hasOwnProperty('area') ? "input-wrapper input-area has-error" : "input-wrapper input-area"}>
                    <Field
                        name="area"
                        label={area}
                        value={selectedArea}
                        accepter={Input}
                        data={areas}
                        onChange={areaChange}
                        /*onOpen={focusInput}*/
                    />
                </div>

                <div className={formErrorAddress.hasOwnProperty('area') ? "input-wrapper input-area has-error" : "input-wrapper input-area"}>
                    <Field
                        name="district"
                        label={district}
                        value={selectedDistrict}
                        accepter={Input}
                        data={districts}
                        onChange={districtChange}
                        /*onOpen={focusInput}*/
                    />
                </div>

                <div className={formErrorAddress.hasOwnProperty('city') ? "input-wrapper input-city has-error" : "input-wrapper input-city"}>
                    <Field
                        name="city"
                        label={city}
                        value={selectedCity}
                        accepter={Input}
                        data={cities}
                        onChange={cityChange}
                        /*onOpen={focusInput}*/
                    />
                </div>

                <div className={formErrorAddress.hasOwnProperty('street') ? "input-wrapper input-street has-error" : "input-wrapper input-street"}>
                    <Field
                        name="street"
                        label={street}
                        data={streets}
                        accepter={Input}
                        value={selectedStreet}
                        onChange={streetChange}
                        /*onOpen={focusInput}*/
                    />
                </div>

                <div className={formErrorAddress.hasOwnProperty('house') ? "input-wrapper input-house has-error" : "input-wrapper input-house"}>
                    <Field
                        name="house"
                        label={house}
                        defaultValue={shippingAddress?.house}
                        //value={address.house}
                        accepter={Input}
                        onChange={houseChange}
                    />
                </div>

                <div className={formErrorAddress.hasOwnProperty('apartment') ? "input-wrapper input-apartment has-error" : "input-wrapper input-apartment"}>
                    <Field
                        name="apartment"
                        label={apartment}
                        defaultValue={shippingAddress?.apartment}
                        //value={address.apartment}
                        accepter={Input}
                        onChange={apartmentChange}
                    />
                </div>

                {onPaymentAndPickupDataChange ? <div className="input-wrapper selectpicker input-payer">
                    <Field
                        name="payer"
                        label={payer}
                        accepter={SelectPicker}
                        searchable={false}
                        data={deliveryPayer}
                        onSelect={deliveryPayerChange}
                        onOpen={focusInput}
                    />
                </div>: null}

                {onPaymentAndPickupDataChange && showPayOnDelivery ? <div className="input-wrapper input-sum">
                    <Field
                        name="sum"
                        label={sum}
                        accepter={Input}
                        onChange={setOrderAmount}
                    />
                </div>: null}
                {onPaymentAndPickupDataChange && showPayOnDelivery ? <div className="pay-method-info">
                    <p>{t('order.payMethod')}</p>
                </div>: null}

                <div className="btn-wrapper">
                    <button
                        disabled={Object.keys(formErrorAddress).length ? true: false}
                        type="submit"
                        className="btn btn-lg"
                        onClick={saveData}>
                        {t('order.save')}
                    </button>
                </div>
            </Form>
            {/*{isSaved ? null : <Tabs selectedIndex={tabIndex}> onSelect={(index) => changeTab(index)}
                <TabList>
                    <Tab onClick={() => saveDeliveryType(1)}>{t('delivery.addressDelivery')}</Tab>
                </TabList>

                <TabPanel>

                </TabPanel>

            </Tabs>}*/}
        </div>
    )
}

export default DeliveryByAddress